import { VideosApprovedTable } from "features/videoUploads/tables/VideosApprovedTable";
import "style/videoMetadataPage.css";
import { useEffect } from "react";
import { setScrollBehavior } from "features/scrollPageBehaviorProvider/scrollPageBehaviorProvider";

export function VideoUploadsInQueuePage() {
	useEffect(() => {
		setScrollBehavior();
	}, []);

	return (
		<div className="videoMetadataList-container">
			<div className="listHeadline">In queue videos:</div>
			<VideosApprovedTable />
		</div>
	);
}
